import script from "./ProductDetailUpsellItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetailUpsellItems.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetailUpsellItems.vue?vue&type=style&index=0&id=ac808bb2&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac808bb2"]])

export default __exports__